import type { MouseEventHandler, ReactNode } from "react";
import MuiButton from "@mui/material/Button";
import type { SxProps, Theme } from "@mui/material/styles";
import classNames from "classnames";

interface ButtonProps {
    children: ReactNode;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    className?: string;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    loading?: boolean; // Shows a spinner and disables the button
}

// Defined once outside the components, so it isn't re-created on every render
const buttonSx: SxProps<Theme> = {
    paddingX: 2,
    paddingY: 1,
    backgroundColor: "#4d4d4d",
    "&:hover": {
        backgroundColor: "#3d3d3d" // Slightly darker on hover
    },
    // Thick bottom border gives the "pressable 3D" look
    borderTop: "2px solid #2d2d2d",
    borderRight: "2px solid #2d2d2d",
    borderLeft: "2px solid #2d2d2d",
    borderBottom: "8px solid #2d2d2d",
    "&:active": {
        borderBottom: "4px solid #2d2d2d"
    },
    color: "#ffffff",
    fontSize: 16,
    textTransform: "none",
    borderRadius: "12px"
};

const Button = ({
                    children,
                    onClick,
                    className,
                    disabled,
                    type = "button",
                    loading
                }: ButtonProps) => {
    return (
        <MuiButton
            variant="contained"
            type={type}
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            className={classNames("gap-x-3 h-fit", className)}
            sx={buttonSx}
        >
            {children}
        </MuiButton>
    );
};

export default Button;